import store from '@/store'

/**
 * Calculate delivery time
 * @start {String} Start address
 * @end {String} Destination address
 * @return {Promise} Delivery time (seconds)
 */
/**
 * 计算配送时间
 * @start {String} 起点地址
 * @end {String} 终点地址
 * @return {Promise} 配送时间（秒）
 */
export function deliveryTime(start, end) {
  const service = new window.google.maps.DistanceMatrixService()
  return new Promise((resolve, reject) => {
    service.getDistanceMatrix({
      origins: [start], // Start address   // 起点地址
      destinations: [end], // Destination address   // 终点地址
      travelMode: 'DRIVING', // Driving mode; BICYCLING - Bicycle; TRANSIT - Bus; WALKING - Walking;   // 开车模式； BICYCLING-自行车;TRANSIT-公交车；WALKING-步行;
      avoidHighways: true, // If true, the route between the start point and the end point will be calculated to avoid the expressway as much as possible   // 如果为 true，则将计算起点和终点之间的路线，以尽可能避开高速公路
      avoidTolls: true, // If true, non toll routes will be used as much as possible to calculate the direction between points   // 如果为 true，则将尽可能使用非收费路线来计算点之间的方向
    }, (response, status) => {
      if (status === 'OK') {
        const data = response?.rows?.[0]?.elements?.[0]?.duration?.value
        if (!data) reject(new Error('failed'))
        else resolve(data)
      } else {
        reject(new Error('failed'))
      }
    })
  })
}